import React, { Fragment, useCallback } from 'react'
import { useSelector } from 'react-redux'

import {
  defaultCustomFieldsOrder,
  MISSING_VALUE,
} from 'ducks/integrations/shopify/constants'
import { capture } from 'ducks/tracking/actions'
import { selectCustomFieldCategoryForKey } from 'ducks/crm/customFieldCategories/selectors'
import { selectCurrentContactId } from 'ducks/crm/contacts'

import ReorderableAndHideableComponents from 'components/ReorderableAndHideableComponents'
import IntegrationCustomField from 'components/crm/ContactDetailsColumn/WidgetCards/cards/CustomFieldCategory/IntegrationCustomField'

import RecentOrders from '../RecentOrders'
import { useShopifyCustomerFields } from './useCustomerDetailsFields'

const CustomerDetails = React.memo(props => {
  const { customerGid, integration, customer } = props

  const keyPrefix = `shopify_${integration.storeDomain}.myshopify.com`

  const { componentOverrides } = useShopifyCustomerFields(keyPrefix, customer)

  const customFieldCategory = useSelector(state =>
    selectCustomFieldCategoryForKey(state, {
      key: keyPrefix,
    })
  )
  const contactId = useSelector(state => selectCurrentContactId(state))
  const initialOrder = defaultCustomFieldsOrder(keyPrefix)

  const handleOnShowToggle = useCallback(shown => {
    if (shown) {
      capture('Shopify Customer Expanded')
    } else {
      capture('Shopify Customer Collapsed')
    }
  }, [])

  return (
    <Fragment>
      <div className="grui pt-7 pl-7 pr-7 pb-4">
        <ReorderableAndHideableComponents
          className="SortableCustomFieldsContainer"
          collection={`category:${customFieldCategory?.id}`}
          initialOrder={initialOrder}
          // eslint-disable-next-line react/jsx-no-bind
          itemComponent={p => (
            <IntegrationCustomField
              {...p}
              componentOverides={componentOverrides}
              missingValueText={MISSING_VALUE}
            />
          )}
          itemProps={{
            categoryType: 'CONTACT',
            subjectId: contactId,
          }}
          itemNoun="field"
          namespace="contact_details_column"
          onToggle={handleOnShowToggle}
        />
      </div>
      <RecentOrders customerId={customerGid} integrationId={integration.id} />
    </Fragment>
  )
})

CustomerDetails.displayName = 'CustomerDetails'

export default CustomerDetails
